import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18f4bbc3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ui-select-link-box" }
const _hoisted_2 = {
  key: 1,
  class: "has-text-box"
}
const _hoisted_3 = { style: {"height":"0","width":"0","overflow":"hidden"} }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowDown = _resolveComponent("ArrowDown")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_cascader = _resolveComponent("el-cascader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.show)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "empty-text-box",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleSelect && _ctx.toggleSelect(...args)))
        }, [
          _createTextVNode(" 请选择跳转页面"),
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_ArrowDown)
            ]),
            _: 1
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_tooltip, {
            content: _ctx.showText,
            disabled: !_ctx.linkEvent,
            placement: "top",
            "show-after": 200,
            "popper-class": "select-link-tip"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "has-block-box",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSelect && _ctx.toggleSelect(...args)))
              }, [
                _createTextVNode(_toDisplayString(_ctx.showName), 1),
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ArrowDown)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["content", "disabled"]),
          _createElementVNode("div", {
            class: "empty-text-box clear-text-box",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearLink && _ctx.clearLink(...args)))
          }, "清除")
        ])),
    _createVNode(_component_el_checkbox, {
      class: "login-check-box",
      "model-value": _ctx.loginCheck,
      "true-label": 1,
      "false-label": 0,
      onChange: _ctx.changeLogin
    }, {
      default: _withCtx(() => [
        _createTextVNode("登录验证")
      ]),
      _: 1
    }, 8, ["model-value", "onChange"]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createBlock(_component_el_cascader, {
        props: { label: 'name' },
        key: _ctx.key,
        options: _ctx.list,
        style: {"width":"0","height":"0"},
        modelValue: _ctx.value_,
        "show-all-levels": false,
        onChange: _ctx.changeEvent,
        ref: "cascader"
      }, {
        default: _withCtx(({ node }) => [
          _createElementVNode("span", {
            onClick: ($event: any) => (_ctx.nodeClick(node))
          }, _toDisplayString(node.label), 9, _hoisted_4)
        ]),
        _: 1
      }, 8, ["options", "modelValue", "onChange"]))
    ])
  ]))
}